module.exports = __webpack_public_path__ + "static/media/logo.d0233d4e.svg";